<span
    class="btn-line"
    *ngIf="outline"
    [ngStyle]="{ 'border-style': lineStyle }"
></span>
<span class="btn-icon before-icon {{ beforeIcon }}" *ngIf="beforeIcon"></span>
<span class="btn-text" [ngClass]="{'d-none d-md-inline': beforeIcon || afterIcon}"><ng-content></ng-content></span>
<span class="btn-icon after-icon {{ afterIcon }}" *ngIf="afterIcon"></span>
